import { domain } from "../../domain";

export {
    shipping
}

function shipping(per_page=null,page=null,id=null,name=null,orderBy=null){
    if(id){
        return `${domain}/pos/pos-shipping?id=${id}`;
    } else if(name){
        return `${domain}/pos/pos-shipping?per_page=${per_page}&page=${page}&name=${name}&orderBy=${orderBy}`
    } else {
        return `${domain}/pos/pos-shipping?per_page=${per_page}&page=${page}&orderBy=${orderBy}`;
    }
}
